import format from 'string-template';

import BaseDocument from '../../Model/BaseDocument';
import { firestorePaths, pathPlaceholder } from '../../utils/paths';

/**
 * Class representing a user's interaction with an announcement.
 *
 * @class UserInteraction
 * @extends BaseDocument
 */
class UserInteraction extends BaseDocument {
  /**
   * Creates an announcement interaction document reference.
   *
   * @param {string} userId - The ID of the user interacting with the announcement.
   * @param {string} announcementId - The ID of the parent announcement.
   * @param {Object} opts - Firestorter/BaseDocument options.
   */
  constructor(userId, announcementId, opts) {
    super(
      `${format(firestorePaths.ANNOUNCEMENT_USER_INTERACTION, {
        [pathPlaceholder.ANNOUNCEMENT_ID]: announcementId,
      })}/${userId}`,
      opts,
    );
  }

  /**
   * Whether the announcement is liked by the user.
   * @returns {boolean}
   */
  get liked() {
    return !!this.data.liked;
  }
}

export default UserInteraction;
